var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPandas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "50px",
    height: "50px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 4,
    width: 5,
    height: 10,
    fill: "#edeeef"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 25,
    width: 5,
    height: 10,
    fill: "#edeeef"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 17,
    width: 5,
    height: 5,
    fill: "#fbc02d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 13,
    width: 5,
    height: 33,
    fill: "#edeeef"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 33,
    width: 5,
    height: 10,
    fill: "#edeeef"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 12,
    width: 5,
    height: 10,
    fill: "#edeeef"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 25,
    width: 5,
    height: 5,
    fill: "#ff4081"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 2,
    width: 5,
    height: 33,
    fill: "#edeeef"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPandas);
export default __webpack_public_path__ + "static/media/pandas.260263d157480fc04d3c38ed4d3f6f92.svg";
export { ForwardRef as ReactComponent };